import script from "./ConfigTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfigTab.vue?vue&type=script&setup=true&lang=ts"

import "./ConfigTab.vue?vue&type=style&index=0&id=34d50346&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34d50346"]])

export default __exports__